export type MediaType = "movie" | "tv" | "variety";

export interface Movie {
  id: string;
  title: string;
  type: MediaType;
  year: number;
  region: string;
  genres: string[];
  score: number;
  duration: string;
  director: string;
  cast: string[];
  language: string;
  releaseDate: string;
  hot: number;
  poster: string;
  backdrop: string;
  summary: string;
  synopsis: string;
}

export const movies: Movie[] = [
  {
    id: "movie-01",
    title: "长夜将尽",
    type: "movie",
    year: 2025,
    region: "中国大陆",
    genres: ["剧情", "悬疑"],
    score: 8.7,
    duration: "128 分钟",
    director: "顾明川",
    cast: ["周砚", "苏晚", "林恒"],
    language: "汉语普通话",
    releaseDate: "2025-09-26",
    hot: 98,
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20of%20a%20solitary%20detective%20in%20a%20long%20coat%20standing%20on%20a%20rain%20soaked%20street%20at%20night%2C%20warm%20amber%20streetlights%20reflecting%20on%20wet%20asphalt%2C%20deep%20charcoal%20shadows%2C%20subtle%20film%20grain%2C%20moody%20editorial%20photography%2C%20clean%20negative%20space%2C%20no%20text&width=600&height=900&seq=fl-poster-movie-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20night%20street%20scene%20with%20rain%20and%20warm%20amber%20lamps%2C%20lone%20silhouette%20walking%20past%20old%20city%20windows%2C%20deep%20charcoal%20and%20burnt%20orange%20tones%2C%20soft%20film%20grain%2C%20atmospheric%20mystery%20movie%20still%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-movie-01&orientation=landscape",
    summary: "一起沉寂十二年的旧案，在雨夜重新浮出水面。",
    synopsis:
      "十二年前的一桩悬案让整座港城陷入漫长的沉默。刑警陆行舟在调离前的最后一晚，收到了一封没有署名的信，信中只有一张旧照片和一句「长夜将尽」。随着调查重启，他发现自己当年最信任的搭档、最亲近的家人，都与这桩案件有着无法切断的联系。真相像一场缓慢退潮的海，最终把所有被掩埋的东西都推回了岸边。",
  },
  {
    id: "movie-02",
    title: "云上列车",
    type: "movie",
    year: 2025,
    region: "日本",
    genres: ["动画", "奇幻", "治愈"],
    score: 8.9,
    duration: "116 分钟",
    director: "新见遥",
    cast: ["配音：花井澪", "配音：佐仓透", "配音：森川千夏"],
    language: "日语",
    releaseDate: "2025-08-15",
    hot: 95,
    poster:
      "https://readdy.ai/api/search-image?query=Hand%20painted%20anime%20style%20poster%20of%20a%20small%20boy%20standing%20on%20a%20floating%20train%20above%20endless%20clouds%2C%20warm%20sunset%20peach%20and%20amber%20sky%2C%20gentle%20glowing%20lanterns%2C%20soft%20illustration%20texture%2C%20dreamy%20whimsical%20composition%2C%20no%20text&width=600&height=900&seq=fl-poster-movie-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Anime%20style%20vast%20sea%20of%20clouds%20at%20golden%20hour%20with%20a%20small%20vintage%20train%20gliding%20across%20the%20sky%2C%20warm%20peach%20and%20amber%20tones%2C%20soft%20brushwork%2C%20dreamy%20whimsical%20atmosphere%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-movie-02&orientation=landscape",
    summary: "一列只在黄昏出现的列车，载着未说出口的告别。",
    synopsis:
      "少年悠真在祖母去世后的夏天，偶然登上一列只在黄昏时分停靠的列车。车上的乘客都带着一件未完成的心事，而列车长告诉他，只有把心事交出去，车才会继续往前开。在这趟没有终点的旅程里，悠真遇见了儿时的自己、没说出口的道歉，以及那个一直在等他的夏天。",
  },
  {
    id: "movie-03",
    title: "归途有风",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    score: 8.2,
    duration: "122 分钟",
    director: "李蔓",
    cast: ["何守成", "周桂英", "许知遥"],
    language: "汉语普通话",
    releaseDate: "2024-11-08",
    hot: 82,
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20realistic%20portrait%20poster%20of%20an%20elderly%20father%20and%20adult%20daughter%20walking%20along%20a%20rural%20road%20with%20autumn%20maple%20leaves%2C%20soft%20afternoon%20light%2C%20muted%20cream%20and%20rust%20palette%2C%20documentary%20photography%20feel%2C%20tender%20emotion%2C%20no%20text&width=600&height=900&seq=fl-poster-movie-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Rural%20countryside%20road%20in%20late%20autumn%20with%20golden%20poplar%20trees%2C%20two%20distant%20figures%20walking%20toward%20an%20old%20village%2C%20soft%20hazy%20sunlight%2C%20warm%20cream%20and%20rust%20color%20palette%2C%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-movie-03&orientation=landscape",
    summary: "父亲最后一次开车送女儿回城，路上走了整整两天。",
    synopsis:
      "在城市打拼多年的女儿接到母亲电话，说父亲执意要亲自开车送她回城。两天一夜的路程里，父女俩几乎不说话，却在每一个服务区、每一段堵车里，把二十多年没能说清的事情慢慢摊开。这是一部关于沉默、体面和迟到的理解的公路电影。",
  },
  {
    id: "movie-04",
    title: "灰烬之城",
    type: "movie",
    year: 2025,
    region: "美国",
    genres: ["动作", "科幻", "冒险"],
    score: 7.9,
    duration: "141 分钟",
    director: "Marcus Vale",
    cast: ["Ethan Cole", "Naomi Reyes", "Dylan Park"],
    language: "英语",
    releaseDate: "2025-07-19",
    hot: 91,
    poster:
      "https://readdy.ai/api/search-image?query=Gritty%20sci-fi%20action%20poster%20of%20a%20lone%20survivor%20in%20a%20cracked%20armor%20suit%20standing%20before%20a%20burning%20ruined%20city%2C%20orange%20embers%20in%20the%20air%2C%20ash%20grey%20sky%2C%20high%20contrast%20cinematic%20lighting%2C%20no%20text&width=600&height=900&seq=fl-poster-movie-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Post%20apocalyptic%20city%20skyline%20in%20smoke%20and%20glowing%20embers%2C%20collapsed%20towers%20and%20orange%20dust%20haze%2C%20tiny%20figure%20walking%20through%20rubble%2C%20epic%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-movie-04&orientation=landscape",
    summary: "当最后一座城市熄灭，他要把火种带到地平线之外。",
    synopsis:
      "能源崩坏后的第七年，灰烬之城只剩下断壁与流民。前工程兵凯尔在一座废弃的反应堆里找到了可能重启电网的核心组件，代价是要穿越被武装势力控制的无人区。他带着一个不会说话的少年上路，在追兵与沙暴之间，重新学会了为什么要活下去。",
  },
  {
    id: "movie-05",
    title: "第七个夏天",
    type: "movie",
    year: 2024,
    region: "中国大陆",
    genres: ["爱情", "青春"],
    score: 7.6,
    duration: "109 分钟",
    director: "沈一白",
    cast: ["陈屿", "温澄", "赵一舟"],
    language: "汉语普通话",
    releaseDate: "2024-08-02",
    hot: 76,
    poster:
      "https://readdy.ai/api/search-image?query=Summer%20youth%20romance%20poster%20of%20two%20teenagers%20sitting%20on%20a%20seaside%20pier%20with%20bicycles%2C%20golden%20sunset%20backlight%2C%20warm%20orange%20and%20pale%20cream%20tones%2C%20soft%20nostalgic%20film%20photography%2C%20gentle%20grain%2C%20no%20text&width=600&height=900&seq=fl-poster-movie-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Quiet%20seaside%20town%20at%20golden%20hour%20with%20old%20bicycles%20leaning%20on%20a%20railing%2C%20warm%20sunlight%20flaring%20across%20the%20frame%2C%20nostalgic%20summer%20cinematic%20still%2C%20muted%20orange%20palette%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-movie-05&orientation=landscape",
    summary: "同一个夏天重来了七次，她终于决定先说那句话。",
    synopsis:
      "高三毕业的那个夏天，林知夏发现自己被困在毕业典礼的前一天，无论怎么过，第二天醒来都会回到原点。她试过逃跑、试过沉默，直到第七次循环，她终于走向那个一直在球场边等她的男生，说出了迟到七年的那句话。",
  },
  {
    id: "movie-06",
    title: "潮汐之下",
    type: "movie",
    year: 2025,
    region: "韩国",
    genres: ["悬疑", "犯罪", "剧情"],
    score: 8.4,
    duration: "132 分钟",
    director: "尹在勋",
    cast: ["朴镇宇", "李恩彩", "金度贤"],
    language: "韩语",
    releaseDate: "2025-06-13",
    hot: 88,
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20crime%20thriller%20poster%20with%20a%20female%20detective%20looking%20toward%20a%20dark%20harbor%20at%20dusk%2C%20cold%20teal%20water%20and%20warm%20lantern%20accents%2C%20tense%20atmosphere%2C%20cinematic%20lighting%2C%20no%20text&width=600&height=900&seq=fl-poster-movie-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Fishing%20harbor%20at%20blue%20hour%20with%20fog%20over%20dark%20water%2C%20old%20boats%20and%20a%20single%20warm%20dock%20light%2C%20moody%20thriller%20cinematic%20wide%20shot%2C%20teal%20and%20amber%20contrast%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-movie-06&orientation=landscape",
    summary: "退潮之后，海滩上留下了不该出现的东西。",
    synopsis:
      "海滨小城连续发生失踪案，负责调查的女警探发现所有线索都指向十五年前的一场海难。随着退潮线一次次后移，被掩埋的物品和证词逐渐显露。她必须在自己父亲的清白与真相之间做出选择。",
  },
  {
    id: "movie-07",
    title: "山海之间",
    type: "movie",
    year: 2024,
    region: "法国",
    genres: ["纪录", "自然"],
    score: 9.1,
    duration: "96 分钟",
    director: "Camille Roux",
    cast: ["旁白：Jeanne Aubert"],
    language: "法语",
    releaseDate: "2024-10-04",
    hot: 79,
    poster:
      "https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20of%20a%20misty%20mountain%20ridge%20meeting%20the%20sea%20at%20sunrise%2C%20layered%20golden%20mist%20and%20pale%20amber%20light%2C%20minimal%20serene%20composition%2C%20high%20detail%20landscape%20photography%2C%20no%20text&width=600&height=900&seq=fl-poster-movie-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Sweeping%20coastal%20mountain%20range%20in%20soft%20morning%20mist%2C%20layers%20of%20pale%20golden%20light%20over%20the%20water%2C%20minimal%20serene%20nature%20documentary%20still%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-movie-07&orientation=landscape",
    summary: "四季轮转之间，山与海的呼吸从未停止。",
    synopsis:
      "摄制组用三年时间跟踪拍摄一片海岸山脉的四季变化，从初春融雪到冬日风暴，记录了岩羊、海鸟与潮间带生物在极端环境中的生存日常。没有旁白式说教，只有风声、水声和漫长的等待。",
  },
  {
    id: "movie-08",
    title: "逆光飞行",
    type: "movie",
    year: 2025,
    region: "中国大陆",
    genres: ["传记", "励志", "剧情"],
    score: 8.0,
    duration: "118 分钟",
    director: "张牧野",
    cast: ["韩铮", "罗晴", "吴建军"],
    language: "汉语普通话",
    releaseDate: "2025-05-01",
    hot: 84,
    poster:
      "https://readdy.ai/api/search-image?query=Inspiring%20biographical%20film%20poster%20of%20a%20young%20pilot%20silhouette%20standing%20before%20a%20small%20aircraft%20at%20sunrise%2C%20warm%20orange%20sky%20and%20dust%20in%20the%20air%2C%20hopeful%20cinematic%20atmosphere%2C%20no%20text&width=600&height=900&seq=fl-poster-movie-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Small%20propeller%20plane%20on%20a%20dusty%20airstrip%20at%20sunrise%2C%20long%20golden%20light%20and%20dust%20haze%2C%20distant%20mountains%2C%20hopeful%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-movie-08&orientation=landscape",
    summary: "被停飞三年后，他用一架旧飞机重新起飞。",
    synopsis:
      "因为一次事故被终身停飞的机长程野，回到老家接手了父亲的农用机场。他把一架报废的旧飞机一点点修好，带着村里从没坐过飞机的孩子们，飞上了那片他以为自己再也看不见的天空。",
  },
  {
    id: "movie-09",
    title: "沙漠邮差",
    type: "movie",
    year: 2023,
    region: "美国",
    genres: ["冒险", "剧情"],
    score: 7.8,
    duration: "127 分钟",
    director: "Nora Hale",
    cast: ["Owen Marsh", "Layla Kim"],
    language: "英语",
    releaseDate: "2023-12-15",
    hot: 68,
    poster:
      "https://readdy.ai/api/search-image?query=Adventure%20drama%20poster%20of%20a%20lone%20traveler%20with%20a%20canvas%20mail%20bag%20crossing%20vast%20desert%20dunes%2C%20warm%20sand%20and%20amber%20sky%2C%20long%20shadows%2C%20minimal%20epic%20composition%2C%20film%20photography%2C%20no%20text&width=600&height=900&seq=fl-poster-movie-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Endless%20desert%20dunes%20at%20late%20afternoon%20with%20a%20tiny%20traveler%20crossing%20the%20sand%2C%20warm%20amber%20and%20pale%20cream%20tones%2C%20minimal%20epic%20cinematic%20landscape%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-movie-09&orientation=landscape",
    summary: "一个人，一袋信，穿越四百公里无人区。",
    synopsis:
      "沙漠深处的小镇失去了与外界的通路，年迈的邮差接下最后一趟任务：把积压了半年的信件送到公路另一头。四百公里的无人区里，他遇见了抛锚的旅人、迷路的少年，也终于在信里读到了自己多年未解的心结。",
  },
  {
    id: "movie-10",
    title: "午夜面包店",
    type: "movie",
    year: 2024,
    region: "日本",
    genres: ["治愈", "剧情"],
    score: 8.6,
    duration: "104 分钟",
    director: "小林澄",
    cast: ["宫本绫", "高桥悠", "吉田修"],
    language: "日语",
    releaseDate: "2024-04-12",
    hot: 87,
    poster:
      "https://readdy.ai/api/search-image?query=Cozy%20Japanese%20healing%20film%20poster%20of%20a%20tiny%20bakery%20glowing%20warmly%20on%20a%20quiet%20night%20street%2C%20steam%20rising%20from%20fresh%20bread%2C%20soft%20amber%20light%2C%20gentle%20film%20grain%2C%20no%20text&width=600&height=900&seq=fl-poster-movie-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Quiet%20Japanese%20alley%20at%20midnight%20with%20a%20small%20bakery%20window%20glowing%20amber%2C%20warm%20light%20spilling%20onto%20stone%20pavement%2C%20soft%20rain%2C%20cozy%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-movie-10&orientation=landscape",
    summary: "只在午夜营业的面包店，卖的是别人的遗憾。",
    synopsis:
      "城市角落有一家只在午夜开门的面包店，店主会根据客人的故事烤出不同的面包。失眠的编辑、刚分手的乐手、带着女儿来道歉的父亲，都在这里坐了一夜。天快亮的时候，每个人都带走了一只还温热的面包。",
  },
  {
    id: "tv-01",
    title: "雾港迷踪",
    type: "tv",
    year: 2025,
    region: "中国大陆",
    genres: ["悬疑", "犯罪", "剧情"],
    score: 9.0,
    duration: "全 24 集",
    director: "陈默",
    cast: ["张砚舟", "刘思彤", "王砚辉"],
    language: "汉语普通话",
    releaseDate: "2025-09-12",
    hot: 99,
    poster:
      "https://readdy.ai/api/search-image?query=Crime%20drama%20series%20poster%20of%20a%20detective%20pair%20standing%20in%20thick%20harbor%20fog%2C%20cold%20grey%20mist%20with%20one%20warm%20orange%20light%20source%2C%20tense%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=fl-poster-tv-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dense%20fog%20over%20an%20old%20industrial%20harbor%20with%20container%20cranes%20and%20a%20single%20sodium%20lamp%20glowing%20orange%2C%20cold%20grey%20blue%20mist%2C%20mysterious%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-tv-01&orientation=landscape",
    summary: "雾散之前，港口里的每一个人都有嫌疑。",
    synopsis:
      "港口城市连续出现无名浮尸，刑警队长与刚从省厅调来的年轻法医组成搭档。随着调查深入，他们发现案件与本地最大的航运集团、以及十年前一次被草草结案的爆炸事故紧密相连。雾越浓，人心越难看清。",
  },
  {
    id: "tv-02",
    title: "京华旧梦",
    type: "tv",
    year: 2025,
    region: "中国大陆",
    genres: ["古装", "剧情", "家庭"],
    score: 8.5,
    duration: "全 40 集",
    director: "沈砚秋",
    cast: ["柳云舒", "顾长风", "白敬言"],
    language: "汉语普通话",
    releaseDate: "2025-03-20",
    hot: 93,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20period%20drama%20poster%20of%20a%20woman%20in%20a%20deep%20rust%20silk%20robe%20standing%20in%20a%20traditional%20courtyard%2C%20warm%20lantern%20light%2C%20falling%20maple%20leaves%2C%20refined%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=fl-poster-tv-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Traditional%20Chinese%20courtyard%20in%20autumn%20with%20red%20lanterns%20and%20falling%20maple%20leaves%2C%20warm%20amber%20moonlight%2C%20layered%20architecture%2C%20elegant%20period%20drama%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-tv-02&orientation=landscape",
    summary: "一座老宅，三代人的账，都要在冬天算清。",
    synopsis:
      "民国初年，京城绸缎世家沈家老太爷病危，散落各地的子女陆续回宅。长子想守着祖业，次女想卖掉宅子办学堂，最小的儿子则带回了一个所有人都没想到的秘密。一个冬天过去，这座宅子里的每个人都被重新排了位置。",
  },
  {
    id: "tv-03",
    title: "北方来信",
    type: "tv",
    year: 2024,
    region: "英国",
    genres: ["剧情", "年代"],
    score: 8.8,
    duration: "全 6 集",
    director: "Eleanor Finch",
    cast: ["Harriet Lowe", "James Wren", "Iris Doyle"],
    language: "英语",
    releaseDate: "2024-11-22",
    hot: 81,
    poster:
      "https://readdy.ai/api/search-image?query=British%20period%20drama%20poster%20of%20a%20woman%20in%20a%20wool%20coat%20holding%20a%20letter%20on%20a%20windy%20northern%20moor%2C%20muted%20cream%20and%20heather%20tones%2C%20overcast%20soft%20light%2C%20cinematic%20photography%2C%20no%20text&width=600&height=900&seq=fl-poster-tv-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Windy%20northern%20English%20moor%20in%20late%20autumn%2C%20dry%20stone%20walls%20and%20bare%20trees%2C%20soft%20overcast%20light%2C%20muted%20cream%20and%20rust%20palette%2C%20period%20drama%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-tv-03&orientation=landscape",
    summary: "战后的小镇，每封信都可能改变一个人的命运。",
    synopsis:
      "二战结束后的第一个冬天，北方小镇的邮局里堆满了寄往各地却无人认领的信。新来的女邮差决定亲自把信送到收件人手上，也因此走进了六个家庭各自封存的战争记忆。",
  },
  {
    id: "tv-04",
    title: "三十九层",
    type: "tv",
    year: 2025,
    region: "韩国",
    genres: ["悬疑", "惊悚"],
    score: 8.1,
    duration: "全 12 集",
    director: "郑河允",
    cast: ["韩素妍", "柳镇浩", "车敏书"],
    language: "韩语",
    releaseDate: "2025-02-06",
    hot: 86,
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20thriller%20series%20poster%20of%20a%20woman%20standing%20alone%20in%20an%20empty%20glass%20office%20corridor%20at%20night%2C%20cold%20grey%20reflections%20and%20a%20single%20warm%20orange%20exit%20sign%2C%20eerie%20cinematic%20lighting%2C%20no%20text&width=600&height=900&seq=fl-poster-tv-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Empty%20modern%20office%20floor%20at%20night%20with%20glass%20walls%20and%20grey%20reflections%2C%20one%20warm%20orange%20light%20at%20the%20far%20end%20of%20the%20corridor%2C%20eerie%20thriller%20cinematic%20shot%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-tv-04&orientation=landscape",
    summary: "整层楼只有她一个人加班，但电梯每晚都停在三十九层。",
    synopsis:
      "新入职的分析师发现，公司大楼的三十九层在建筑图纸上并不存在，可电梯每晚都会在那里停一次。她开始记录每一次异常，也逐渐意识到，自己正在被卷进一场精心设计的职场清除计划。",
  },
  {
    id: "tv-05",
    title: "春山可望",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["家庭", "剧情", "治愈"],
    score: 8.3,
    duration: "全 32 集",
    director: "林知远",
    cast: ["宋清和", "韩梅", "陆时"],
    language: "汉语普通话",
    releaseDate: "2024-09-18",
    hot: 78,
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20family%20drama%20poster%20of%20a%20grandmother%20and%20grandson%20on%20a%20green%20hillside%20above%20a%20small%20village%2C%20morning%20mist%20and%20golden%20sunlight%2C%20gentle%20documentary%20photography%2C%20no%20text&width=600&height=900&seq=fl-poster-tv-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Terraced%20green%20hillside%20village%20in%20early%20spring%20mist%2C%20warm%20morning%20sunlight%20breaking%20through%2C%20soft%20natural%20tones%2C%20peaceful%20cinematic%20landscape%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-tv-05&orientation=landscape",
    summary: "回到山里的小院，她把日子重新过了一遍。",
    synopsis:
      "在城市生活了十五年的设计师因为一场变故回到老家，接手外婆留下的院子。她要面对的不只是漏雨的屋顶和荒废的茶园，还有那些她以为早就放下的家人与旧事。",
  },
  {
    id: "tv-06",
    title: "数据深渊",
    type: "tv",
    year: 2025,
    region: "美国",
    genres: ["科幻", "惊悚", "悬疑"],
    score: 8.7,
    duration: "全 8 集",
    director: "Alan Frost",
    cast: ["Clara Voss", "Nate Irwin", "Sofia Lang"],
    language: "英语",
    releaseDate: "2025-08-08",
    hot: 90,
    poster:
      "https://readdy.ai/api/search-image?query=Sci-fi%20thriller%20poster%20of%20a%20person%20facing%20a%20wall%20of%20glowing%20amber%20data%20streams%20in%20a%20dark%20server%20room%2C%20cold%20grey%20and%20warm%20orange%20contrast%2C%20high%20tech%20cinematic%20atmosphere%2C%20no%20text&width=600&height=900&seq=fl-poster-tv-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dark%20server%20corridor%20with%20rows%20of%20blinking%20amber%20lights%20and%20cold%20grey%20metal%2C%20thin%20haze%2C%20high%20tech%20thriller%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-tv-06&orientation=landscape",
    summary: "一段不该存在的代码，正在替所有人做决定。",
    synopsis:
      "某天清晨，全球三千万人的日程被同一套算法悄悄改写。负责审计的工程师发现，这套系统的训练数据里混入了一段不属于任何人的记忆。她越查越深，也越不确定自己是不是也在被计算之中。",
  },
  {
    id: "tv-07",
    title: "小城食光",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["美食", "治愈", "剧情"],
    score: 8.9,
    duration: "全 20 集",
    director: "周梧",
    cast: ["李念", "陈建国", "阿雅"],
    language: "汉语普通话",
    releaseDate: "2024-06-28",
    hot: 89,
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20food%20drama%20poster%20of%20a%20small%20street%20kitchen%20at%20dusk%20with%20steaming%20noodles%20and%20a%20smiling%20cook%2C%20golden%20lantern%20light%2C%20rich%20amber%20tones%2C%20cozy%20cinematic%20photography%2C%20no%20text&width=600&height=900&seq=fl-poster-tv-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Small%20Chinese%20town%20night%20market%20alley%20with%20steaming%20food%20stalls%20and%20warm%20hanging%20lanterns%2C%20rich%20amber%20light%2C%20cozy%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-tv-07&orientation=landscape",
    summary: "一间小面馆，装下了半条街的人生。",
    synopsis:
      "小城老街上有家开了三十年的面馆，老板娘每天只做十二碗面。每一集围绕一位客人展开，他们带着各自的疲惫坐下来，吃完一碗面，再走回自己的生活。",
  },
  {
    id: "tv-08",
    title: "白色回声",
    type: "tv",
    year: 2023,
    region: "冰岛",
    genres: ["悬疑", "剧情"],
    score: 8.0,
    duration: "全 8 集",
    director: "Sigrun Holt",
    cast: ["Elin Dahl", "Bjorn Vik"],
    language: "冰岛语",
    releaseDate: "2023-10-27",
    hot: 62,
    poster:
      "https://readdy.ai/api/search-image?query=Nordic%20noir%20series%20poster%20of%20a%20figure%20in%20a%20red%20coat%20standing%20in%20a%20vast%20white%20snow%20field%20at%20twilight%2C%20cold%20blue%20shadows%20with%20one%20warm%20window%20light%2C%20minimal%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=fl-poster-tv-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Vast%20Icelandic%20snow%20field%20at%20twilight%20with%20a%20single%20isolated%20house%20and%20warm%20window%20light%2C%20cold%20pale%20blue%20shadows%2C%20minimal%20Nordic%20noir%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-tv-08&orientation=landscape",
    summary: "雪原上的一座疗养院，收留了不愿说话的人。",
    synopsis:
      "极夜开始的第一周，雪原疗养院来了一位不肯开口的新住客。护士发现她的病历上写着一个已经去世七年的名字，而档案室里的旧录音带，正在一格一格地自己转动。",
  },
  {
    id: "tv-09",
    title: "追风少年",
    type: "tv",
    year: 2024,
    region: "中国大陆",
    genres: ["青春", "运动"],
    score: 7.7,
    duration: "全 28 集",
    director: "许放",
    cast: ["沈亦然", "林小满", "郑野"],
    language: "汉语普通话",
    releaseDate: "2024-07-12",
    hot: 74,
    poster:
      "https://readdy.ai/api/search-image?query=Youth%20sports%20drama%20poster%20of%20teenage%20cyclists%20racing%20on%20a%20coastal%20road%20at%20sunset%2C%20dynamic%20motion%2C%20warm%20orange%20backlight%2C%20energetic%20cinematic%20photography%2C%20no%20text&width=600&height=900&seq=fl-poster-tv-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Coastal%20highway%20at%20golden%20hour%20with%20a%20group%20of%20teenage%20cyclists%20riding%20toward%20the%20sun%2C%20warm%20orange%20flare%2C%20energetic%20youth%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-tv-09&orientation=landscape",
    summary: "一支被解散的车队，要骑完最后一场比赛。",
    synopsis:
      "县中学的自行车队因为经费问题被解散，五个少年决定用一辆拼装车参加省赛。他们没有教练、没有场地，只有一条每天要骑四十公里的训练路线，和一个不想认输的夏天。",
  },
  {
    id: "tv-10",
    title: "灯火人间",
    type: "tv",
    year: 2025,
    region: "中国大陆",
    genres: ["都市", "剧情"],
    score: 8.2,
    duration: "全 36 集",
    director: "梁书",
    cast: ["周砚秋", "方宁", "唐野"],
    language: "汉语普通话",
    releaseDate: "2025-01-16",
    hot: 85,
    poster:
      "https://readdy.ai/api/search-image?query=Urban%20ensemble%20drama%20poster%20of%20a%20city%20apartment%20balcony%20at%20night%20with%20warm%20window%20lights%20and%20distant%20skyline%2C%20soft%20amber%20glow%2C%20intimate%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=fl-poster-tv-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=City%20residential%20buildings%20at%20night%20with%20hundreds%20of%20warm%20lit%20windows%2C%20soft%20mist%2C%20quiet%20urban%20cinematic%20wide%20shot%2C%20warm%20amber%20and%20deep%20grey%20tones%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-tv-10&orientation=landscape",
    summary: "同一栋楼里，六户人家，六种活法。",
    synopsis:
      "一栋老式居民楼即将加装电梯，六户人家因为费用分摊第一次坐到一起。装修噪音、孩子上学、老人照护、失业与和解，琐碎的日子在楼道里交错，最后拼成了这座城市最真实的模样。",
  },
  {
    id: "variety-01",
    title: "向往的山野",
    type: "variety",
    year: 2025,
    region: "中国大陆",
    genres: ["真人秀", "生活", "治愈"],
    score: 8.8,
    duration: "全 12 期",
    director: "总导演：吴桐",
    cast: ["常驻：黄远", "常驻：林知夏", "常驻：小满"],
    language: "汉语普通话",
    releaseDate: "2025-06-06",
    hot: 96,
    poster:
      "https://readdy.ai/api/search-image?query=Lifestyle%20reality%20show%20poster%20of%20a%20small%20wooden%20cabin%20in%20a%20green%20mountain%20valley%2C%20warm%20morning%20light%2C%20vegetable%20garden%20and%20hanging%20laundry%2C%20cheerful%20rustic%20atmosphere%2C%20warm%20amber%20tones%2C%20no%20text&width=600&height=900&seq=fl-poster-variety-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Idyllic%20mountain%20valley%20with%20a%20small%20wooden%20farmhouse%20and%20vegetable%20garden%20at%20golden%20hour%2C%20warm%20amber%20sunlight%2C%20lush%20green%20hills%2C%20cheerful%20lifestyle%20show%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-variety-01&orientation=landscape",
    summary: "三个城里人，在山里从零开始种一季菜。",
    synopsis:
      "三位常驻嘉宾在山村租下一块荒地，从翻土、育苗到收成，完整经历一整个农季。节目不设任务卡，只有节气、天气和一日三餐，把「慢」拍成了一件具体的事。",
  },
  {
    id: "variety-02",
    title: "声音的旅行",
    type: "variety",
    year: 2025,
    region: "中国大陆",
    genres: ["音乐", "竞演"],
    score: 8.6,
    duration: "全 10 期",
    director: "总导演：叶南",
    cast: ["导师：陈以安", "导师：苏禾", "导师：周野"],
    language: "汉语普通话",
    releaseDate: "2025-04-18",
    hot: 92,
    poster:
      "https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%20of%20a%20singer%20silhouette%20on%20a%20warm%20lit%20stage%20surrounded%20by%20floating%20dust%20and%20amber%20spotlights%2C%20dramatic%20yet%20warm%20atmosphere%2C%20no%20text&width=600&height=900&seq=fl-poster-variety-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Warm%20amber%20concert%20stage%20with%20a%20single%20microphone%20stand%20and%20soft%20light%20beams%20in%20haze%2C%20empty%20audience%20seats%20in%20shadow%2C%20elegant%20music%20show%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-variety-02&orientation=landscape",
    summary: "把一首歌带到它诞生的地方去唱。",
    synopsis:
      "节目组带着歌手离开录音棚，去到歌曲的灵感来源地——渔村、戈壁、老工厂、校园天台，在真实的环境里重新编曲、重新演唱，让声音回到它最初生长的地方。",
  },
  {
    id: "variety-03",
    title: "一日主厨",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["美食", "挑战", "真人秀"],
    score: 8.3,
    duration: "全 12 期",
    director: "总导演：何川",
    cast: ["主持：王见山", "常驻：刘小厨", "常驻：顾一"],
    language: "汉语普通话",
    releaseDate: "2024-10-11",
    hot: 80,
    poster:
      "https://readdy.ai/api/search-image?query=Cooking%20show%20poster%20of%20an%20amateur%20chef%20plating%20a%20rustic%20dish%20in%20a%20warm%20professional%20kitchen%2C%20steam%20and%20amber%20light%2C%20lively%20atmosphere%2C%20cinematic%20food%20photography%2C%20no%20text&width=600&height=900&seq=fl-poster-variety-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Warm%20open%20kitchen%20with%20copper%20pans%20and%20steaming%20pots%2C%20soft%20amber%20light%2C%20rustic%20wooden%20counter%2C%20cozy%20cooking%20show%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-variety-03&orientation=landscape",
    summary: "普通人只做一天主厨，要撑起一整间餐厅。",
    synopsis:
      "每期邀请一位完全没有后厨经验的普通人，在一天之内接管一家真实营业的餐厅。从买菜、备料到出餐，所有失误都会被真实记录，而最后那一桌客人，往往比评分更重要。",
  },
  {
    id: "variety-04",
    title: "舞台之下",
    type: "variety",
    year: 2025,
    region: "中国大陆",
    genres: ["舞蹈", "竞演"],
    score: 8.5,
    duration: "全 10 期",
    director: "总导演：陈斯",
    cast: ["队长：杨澈", "队长：许宁", "队长：Mi"],
    language: "汉语普通话",
    releaseDate: "2025-07-25",
    hot: 88,
    poster:
      "https://readdy.ai/api/search-image?query=Dance%20competition%20poster%20of%20a%20dancer%20mid%20movement%20in%20a%20dim%20rehearsal%20studio%2C%20warm%20amber%20light%20streaks%20and%20deep%20shadow%2C%20dynamic%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=fl-poster-variety-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Empty%20dance%20rehearsal%20studio%20with%20wooden%20floor%20and%20mirrors%2C%20warm%20amber%20light%20from%20tall%20windows%2C%20dust%20in%20the%20air%2C%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-variety-04&orientation=landscape",
    summary: "聚光灯之外，他们用三十天排一支舞。",
    synopsis:
      "来自不同舞种的二十四位舞者被随机分成四队，三十天内完成原创作品。节目把大部分镜头留在了排练厅：争执、受伤、重排、和解，直到灯光亮起的那一刻。",
  },
  {
    id: "variety-05",
    title: "出发吧！少年",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["旅行", "真人秀"],
    score: 7.9,
    duration: "全 14 期",
    director: "总导演：林一舟",
    cast: ["常驻：小北", "常驻：阿哲", "常驻：Momo"],
    language: "汉语普通话",
    releaseDate: "2024-05-17",
    hot: 72,
    poster:
      "https://readdy.ai/api/search-image?query=Travel%20reality%20show%20poster%20of%20three%20young%20travelers%20with%20backpacks%20on%20a%20mountain%20trail%20at%20sunrise%2C%20warm%20golden%20light%2C%20wide%20open%20valley%20behind%20them%2C%20energetic%20cinematic%20photography%2C%20no%20text&width=600&height=900&seq=fl-poster-variety-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Mountain%20trail%20at%20sunrise%20with%20three%20hikers%20walking%20toward%20a%20wide%20valley%2C%20warm%20golden%20light%20and%20soft%20mist%2C%20energetic%20travel%20show%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-variety-05&orientation=landscape",
    summary: "没有攻略，只有一个方向和很少的钱。",
    synopsis:
      "三位年轻嘉宾带着有限预算出发，每期只拿到一个目的地和一句线索。他们要靠搭车、问路和临时打工抵达终点，沿途遇见的人，构成了这趟旅程真正的风景。",
  },
  {
    id: "variety-06",
    title: "推理之夜",
    type: "variety",
    year: 2025,
    region: "韩国",
    genres: ["推理", "游戏", "真人秀"],
    score: 8.7,
    duration: "全 12 期",
    director: "总导演：朴贤宇",
    cast: ["固定：金泰河", "固定：李书妍", "固定：郑宇成"],
    language: "韩语",
    releaseDate: "2025-05-09",
    hot: 94,
    poster:
      "https://readdy.ai/api/search-image?query=Mystery%20game%20show%20poster%20of%20players%20around%20a%20dim%20table%20lit%20by%20warm%20candles%20and%20clues%2C%20deep%20shadow%20with%20amber%20highlights%2C%20tense%20theatrical%20atmosphere%2C%20no%20text&width=600&height=900&seq=fl-poster-variety-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dim%20elegant%20mansion%20dining%20room%20lit%20by%20candles%20with%20scattered%20clues%20on%20a%20long%20table%2C%20warm%20amber%20glow%20and%20deep%20shadows%2C%20mystery%20show%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-variety-06&orientation=landscape",
    summary: "六个人，一桩虚构案件，只有一个人说了真话。",
    synopsis:
      "每期构建一个完整的虚构案件，六位玩家被投放到不同身份中，通过搜证、盘问和公开讨论找出真相。节目不提供旁白提示，观众与玩家同步获得线索。",
  },
  {
    id: "variety-07",
    title: "森林音乐会",
    type: "variety",
    year: 2024,
    region: "日本",
    genres: ["音乐", "治愈"],
    score: 9.0,
    duration: "全 8 期",
    director: "总导演：森田透",
    cast: ["主持：中村绫", "嘉宾：青木遥", "嘉宾：Kenta"],
    language: "日语",
    releaseDate: "2024-09-06",
    hot: 83,
    poster:
      "https://readdy.ai/api/search-image?query=Slow%20music%20show%20poster%20of%20a%20small%20string%20ensemble%20playing%20among%20tall%20forest%20trees%2C%20warm%20sunbeams%20through%20leaves%2C%20serene%20amber%20green%20palette%2C%20cinematic%20photography%2C%20no%20text&width=600&height=900&seq=fl-poster-variety-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Sunlight%20streaming%20through%20a%20tall%20quiet%20forest%20with%20a%20small%20wooden%20stage%20and%20instruments%2C%20soft%20amber%20green%20tones%2C%20serene%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-variety-07&orientation=landscape",
    summary: "在森林里，为一棵树办一场音乐会。",
    synopsis:
      "节目每期选一片森林，邀请音乐人现场创作一首曲子，并在日落时分完成一场只有几十位听众的演出。没有修音，没有返场，风和林鸟都是演出的一部分。",
  },
  {
    id: "variety-08",
    title: "了不起的手艺",
    type: "variety",
    year: 2023,
    region: "中国大陆",
    genres: ["文化", "纪录"],
    score: 8.9,
    duration: "全 10 期",
    director: "总导演：徐立",
    cast: ["讲述：苏白"],
    language: "汉语普通话",
    releaseDate: "2023-11-10",
    hot: 69,
    poster:
      "https://readdy.ai/api/search-image?query=Cultural%20documentary%20poster%20of%20an%20old%20craftsman%20working%20with%20wood%20in%20a%20warm%20sunlit%20workshop%2C%20visible%20wood%20shavings%20and%20hand%20tools%2C%20muted%20amber%20and%20earth%20tones%2C%20no%20text&width=600&height=900&seq=fl-poster-variety-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Rustic%20woodworking%20workshop%20with%20hand%20tools%20and%20wood%20shavings%20on%20a%20bench%2C%20warm%20afternoon%20light%20through%20dusty%20windows%2C%20muted%20amber%20earth%20tones%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-variety-08&orientation=landscape",
    summary: "十门快要失传的手艺，和还在坚持的人。",
    synopsis:
      "摄制组走访十个省份，记录木作、制瓷、织染、打铁等传统手艺的完整工序。镜头不回避枯燥与重复，也拍下了老师傅们对手上这门活最朴素的理解。",
  },
  {
    id: "variety-09",
    title: "极限48小时",
    type: "variety",
    year: 2025,
    region: "美国",
    genres: ["冒险", "挑战", "真人秀"],
    score: 7.8,
    duration: "全 10 期",
    director: "总导演：Ryan Holt",
    cast: ["主持：Mia Grant", "参赛：六组素人"],
    language: "英语",
    releaseDate: "2025-03-07",
    hot: 77,
    poster:
      "https://readdy.ai/api/search-image?query=Adventure%20challenge%20show%20poster%20of%20two%20contestants%20crossing%20a%20narrow%20canyon%20bridge%20at%20dusk%2C%20warm%20orange%20sky%20and%20deep%20shadow%2C%20dramatic%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=fl-poster-variety-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dramatic%20desert%20canyon%20at%20dusk%20with%20a%20thin%20suspension%20bridge%2C%20warm%20orange%20sky%20and%20deep%20rock%20shadows%2C%20adventure%20show%20cinematic%20wide%20shot%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-variety-09&orientation=landscape",
    summary: "48 小时，一张地图，没有第二次机会。",
    synopsis:
      "六组素人搭档被投放到陌生地域，须在 48 小时内完成一系列地理与协作挑战。节目不设淘汰，只记录每组在时间压力下的真实反应与默契。",
  },
  {
    id: "variety-10",
    title: "深夜书房",
    type: "variety",
    year: 2024,
    region: "中国大陆",
    genres: ["访谈", "文化"],
    score: 8.4,
    duration: "全 16 期",
    director: "总导演：程未",
    cast: ["主持：沈知", "嘉宾：每期一位创作者"],
    language: "汉语普通话",
    releaseDate: "2024-12-06",
    hot: 71,
    poster:
      "https://readdy.ai/api/search-image?query=Intimate%20talk%20show%20poster%20of%20two%20people%20conversing%20across%20a%20warm%20lamp%20lit%20desk%20stacked%20with%20books%2C%20deep%20shadows%20and%20amber%20glow%2C%20quiet%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=fl-poster-variety-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cozy%20late%20night%20study%20with%20floor%20to%20ceiling%20bookshelves%2C%20a%20single%20warm%20desk%20lamp%20and%20two%20chairs%2C%20soft%20amber%20glow%2C%20quiet%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=fl-backdrop-variety-10&orientation=landscape",
    summary: "一场没有提词器的深夜长谈。",
    synopsis:
      "每期邀请一位创作者，在深夜的书房里聊两个小时。没有宣传任务，也不聊热搜，只聊最近在读的书、卡住的作品和那些不太成功的决定。",
  },
];